import * as OTPAuth from "otpauth";

// Demo user credentials from env vars
const DEMO_CREDENTIALS = {
  username: process.env.REACT_APP_DEMO_USERNAME || "demo@sbi.com",
  password: process.env.REACT_APP_DEMO_PASSWORD || "SafeBrain2026",
  totpSecret: process.env.REACT_APP_DEMO_TOTP_SECRET || "JBSWY3DPEHPK3PXP",
  userInfo: {
    first_name: process.env.REACT_APP_DEMO_FIRST_NAME || "Demo",
    last_name: process.env.REACT_APP_DEMO_LAST_NAME || "User",
    email: process.env.REACT_APP_DEMO_USERNAME || "demo@sbi.com",
    user_id: "demo-user-001",
  },
};

// Verify username and password
export function verifyCredentials(username, password) {
  return (
    username === DEMO_CREDENTIALS.username &&
    password === DEMO_CREDENTIALS.password
  );
}

// Generate mock tokens
export function generateMockTokens() {
  return {
    accessToken: "mock-access-token-" + Date.now(),
    refreshToken: "mock-refresh-token-" + Date.now(),
  };
}

// Get user info
export function getUserInfo() {
  return DEMO_CREDENTIALS.userInfo;
}

// Generate TOTP instance
export function getTOTPInstance() {
  return new OTPAuth.TOTP({
    issuer: "Safe Brain Initiative",
    label: DEMO_CREDENTIALS.username,
    algorithm: "SHA1",
    digits: 6,
    period: 30,
    secret: DEMO_CREDENTIALS.totpSecret,
  });
}

// Generate QR code URI for authenticator apps
export function generate2FASetupURI() {
  const totp = getTOTPInstance();
  return totp.toString(); // Returns otpauth://totp/... URI
}

// Get the secret for manual entry
export function get2FASecret() {
  return DEMO_CREDENTIALS.totpSecret;
}

// Verify TOTP code
export function verify2FACode(code) {
  try {
    const totp = getTOTPInstance();
    // Validate with window of 1 (allows ±30 seconds for clock skew)
    const delta = totp.validate({ token: code, window: 1 });
    return delta !== null; // Returns true if valid
  } catch (error) {
    console.error("2FA verification error:", error);
    return false;
  }
}
